import { downloadRecipientProfilePDFAPi } from '@/api/v1/organization/vendor-vault/downloadRecipientProfilePDFApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const downloadRecipientProfilePDF = async (token: string) => {
  const response = await downloadRecipientProfilePDFAPi(token);

  try {
    return prepareResponse(response, ['Content-Disposition']);
  } catch (e) {
    throwResponseError(e);
  }
};
